import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { PanelBlock } from '../types';
import { DescriptionBlocks } from '../DescriptionBlocks';
import styles from './Panel.module.css';
interface PanelProps {
  block: PanelBlock;
  blockId: string;
}
export function Panel(t0) {
  const $ = _c(10);
  const {
    block,
    blockId
  } = t0;
  const variantClass = block.variant === "well" ? styles.well : block.variant === "vcaIntro" ? styles.vcaIntro : block.variant === "homeSecurityDifference" ? styles.homeSecurityDifference : block.accent === "blue" ? styles.blue : styles.orange;
  const t1 = `${styles.panel} ${variantClass}`;
  let t2;
  if ($[0] !== block.title) {
    t2 = block.title ? <h3 className={styles.title}>{block.title}</h3> : null;
    $[0] = block.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${blockId}.body`;
  let t4;
  if ($[2] !== block.blocks || $[3] !== t3) {
    t4 = <DescriptionBlocks blocks={block.blocks} blockIdPrefix={t3} />;
    $[2] = block.blocks;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== blockId || $[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <section className={t1} data-cms-block-id={blockId} data-cms-field="panel">{t2}{t4}</section>;
    $[5] = blockId;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}